import React, {useEffect}  from "react";
import Navbar from "../Components/Navbar";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaLaptopCode,
  FaUsers,
  FaAward,
  FaRocket,
} from "react-icons/fa";


export default function About() {
   const navigate = useNavigate();
   useEffect(() => {
     window.scrollTo({
       top: 0,
       left: 0,
       behavior: "instant",
     });
   }, []);
  return (
    <>
      <Navbar />

      <div className="relative min-h-screen text-white">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="fixed inset-0 w-full h-full object-cover -z-20"
        >
          <source src="/videos/bg.mp4" type="video/mp4" />
        </video>
        <div className="fixed inset-0 bg-black/40 -z-10"></div>

        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">

            <div>
              <img
                src="/images/about.jpg"
                alt="About"
                className="rounded-2xl shadow-2xl"
              />
            </div>

            <div>
              <h2 className="text-4xl font-bold mb-6 text-cyan-400">
                Who We Are
              </h2>

              <p className="text-gray-300 leading-8 mb-5">
                JK Solution is a leading software development company
                providing modern IT solutions to startups, enterprises,
                and organizations. We specialize in custom software,
                web development, mobile application development,
                cloud solutions, UI/UX design, and digital transformation.
              </p>

              <p className="text-gray-300 leading-8">
                Our team combines creativity, innovation, and advanced
                technology to build scalable and secure solutions that
                help businesses achieve long-term success.
              </p>
            </div>

          </div>
        </section>
        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10">

            <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl">
              <h3 className="text-3xl font-bold text-cyan-400 mb-4">
                Our Mission
              </h3>

              <p className="text-gray-300 leading-8">
                To empower businesses through innovative technology
                solutions that improve efficiency, productivity,
                and customer engagement while maintaining the highest
                quality standards.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl">
              <h3 className="text-3xl font-bold text-cyan-400 mb-4">
                Our Vision
              </h3>

              <p className="text-gray-300 leading-8">
                To become a globally trusted technology partner by
                delivering cutting-edge digital solutions that drive
                growth and create lasting business value.
              </p>
            </div>

          </div>
        </section>

        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto">

            <h2 className="text-center text-5xl font-bold mb-14">
              Why Choose Us
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

              <div className="bg-white/10 p-8 rounded-2xl text-center">
                <FaLaptopCode className="text-cyan-400 text-6xl mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">
                  Modern Technology
                </h3>
                <p className="text-gray-300">
                  Latest frameworks and tools for scalable applications.
                </p>
              </div>

              <div className="bg-white/10 p-8 rounded-2xl text-center">
                <FaUsers className="text-cyan-400 text-6xl mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">
                  Expert Team
                </h3>
                <p className="text-gray-300">
                  Skilled developers with real-world industry experience.
                </p>
              </div>

              <div className="bg-white/10 p-8 rounded-2xl text-center">
                <FaAward className="text-cyan-400 text-6xl mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">
                  Quality Focus
                </h3>
                <p className="text-gray-300">
                  Reliable, secure, and high-performance solutions.
                </p>
              </div>

              <div className="bg-white/10 p-8 rounded-2xl text-center">
                <FaRocket className="text-cyan-400 text-6xl mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">
                  Fast Delivery
                </h3>
                <p className="text-gray-300">
                  Timely project completion with continuous support.
                </p>
              </div>

            </div>

          </div>
        </section>

        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto">

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">

              <div>
                <h2 className="text-5xl font-bold text-cyan-400">
                  100+
                </h2>
                <p className="mt-3 text-gray-300">
                  Projects Completed
                </p>
              </div>

              <div>
                <h2 className="text-5xl font-bold text-cyan-400">
                  50+
                </h2>
                <p className="mt-3 text-gray-300">
                  Happy Clients
                </p>
              </div>

              <div>
                <h2 className="text-5xl font-bold text-cyan-400">
                  10+
                </h2>
                <p className="mt-3 text-gray-300">
                  Years Experience
                </p>
              </div>

              <div>
                <h2 className="text-5xl font-bold text-cyan-400">
                  24/7
                </h2>
                <p className="mt-3 text-gray-300">
                  Support Available
                </p>
              </div>

            </div>

          </div>
        </section>
  <div className="bg-black/70 backdrop-blur-md py-12">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid md:grid-cols-3 gap-10">

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                Kerala Branch
              </h3>

              <p className="leading-7">
                1st Floor - JK Building
                <br />
                Kannur, Kannur 670684
                <br />
                Phone: +91 90000 90000
              </p>

              <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
                Tamil Nadu Branch
              </h3>

              <p className="leading-7">
                First Floor, D Block,
                <br />
                JK Park, chennai,
                <br />
                Chennai, Tamil Nadu 600100
                <br />
                Phone: +91 70000 80000
                <br />
                Email: jk@gmail.com
              </p>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                Quick Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/home")}>Home</li>
                <li  className="cursor-pointer" onClick={() => navigate("/about")}>About Us</li>
                <li className="cursor-pointer"  onClick={() => navigate("/services")}>Services</li>
                <li  className="cursor-pointer" onClick={() => navigate("/product")}>Products</li>
             

              </ul>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                More Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/careers")}>Career</li>
                <li className="cursor-pointer"  onClick={() => navigate("/events")}>Events</li>
                <li  className="cursor-pointer" onClick={() => navigate("/blogs")}>Blogs</li>

              </ul>

            </div>

          </div>

        </div>

      </div>
      </div>
    </>
  );
}